import React from 'react';
import './InProgress.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

interface InProgressProps {
  count: number;
  isActive?: boolean;
}

const InProgress: React.FC<InProgressProps> = ({ count, isActive = false }) => {
  return (
    <div
      className={`table-task-in-progress-container ${isActive ? 'active' : ''}`}
    >
      <span className="data-bar-icon inprogress">
        <FontAwesomeIcon icon={faSpinner} />
      </span>
      <span className="table-task-in-progress-label">In-Progress</span>
      <span className="table-task-in-progress-count">{count}</span>
    </div>
  );
};

export default InProgress;
